import React from 'react'

/**
 * The read-only counterpart to FormField: icon, label, value. Used for
 * everything in a detail modal that isn't a headline fact.
 */
const DataRow = ({ icon, label, value, children, className = '' }) => (
  <div className={className}>
    <div className='app-modal__row-label'>
      {icon}
      {label}
    </div>
    {children || <p className='app-modal__row-value'>{value || '-'}</p>}
  </div>
)

export default DataRow
